import { z } from 'zod';

export const sendMobileVerificationCodeResponseSchema = z.object({
  codeTriesLeft: z.number(),
});

export const getMobileVerificationResponseSchema = z.object({
  isVerified: z.boolean(),
});
